import React, { Component } from "react";
import { Segment, Grid, Accordion, Table } from "semantic-ui-react";
import _ from "lodash";
import ReportSummary from "../ReportSummary";
import Property from "./Property";
import PrintReportCaseHeader from "../PrintReportCaseHeader";
import SimpleAccordionContent from "../../common/SimpleAccordionContent";

class PropertyReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: 0,
    };
    this.loadData(props);
  }

  componentWillReceiveProps(nextProps) {
    this.loadData(nextProps);
  }

  onReportIndexChanged = (currentIndex) => {
    this.changeReport(currentIndex);
    const element = document.getElementById(`acc_row_${currentIndex}`);
    element.scrollIntoView();
  };

  onReportPrint = () => {
    const accordionIndexes = this.state.accordionIndexes;
    _.forEach(accordionIndexes, (acc, accIndex) => {
      accordionIndexes[accIndex] = true;
    });
    this.setState({ accordionIndexes });
  };

  loadData = (props) => {
    if (props.reportData !== undefined) {
      const repRecords = _.get(
        props.reportData,
        `${Object.keys(
          this.props.reportData
        )}.propertyReport[0].propertyReportRecord`
      );
      const accordionIndexes = [];
      _.forEach(repRecords, () => {
        accordionIndexes.push(false);
      });
      if (accordionIndexes.length > 0) accordionIndexes[0] = true;
      this.state = {
        activeIndex: 0,
        accordionIndexes,
      };
    }
  };

  handleClick = (e, index) => {
    this.changeReport(index);
  };

  changeReport = (index) => {
    const { activeIndex } = this.state;
    const accordionIndexes = this.state.accordionIndexes;
    _.forEach(accordionIndexes, (acc, accIndex) => {
      accordionIndexes[accIndex] = false;
    });
    accordionIndexes[index] = !accordionIndexes[index];
    if (activeIndex !== index) {
      const newIndex = activeIndex === index ? -1 : index;
      this.setState({
        activeIndex: newIndex,
        accordionIndexes,
      });
    } else {
      this.setState({
        accordionIndexes,
      });
    }
  };

  render() {
    // const records = [];
    const propTitles = [];
    const list = [];
    let actId;
    if (this.props.reportData !== undefined) {
      actId = _.get(
        this.props.reportData,
        `${Object.keys(this.props.reportData)[0]}.log[0].actID[0]`
      );

      let repRecords = _.get(
        this.props.reportData,
        `${Object.keys(
          this.props.reportData
        )}.propertyReport[0].propertyReportRecord`
      );
      if (!repRecords || repRecords.length < 1) {
        repRecords = _.get(
          this.props.reportData,
          `${Object.keys(this.props.reportData)}.property[0].record`
        );
      }
      if (!repRecords || repRecords.length < 1) {
        const propRepRecords = _.get(
          this.props.reportData,
          `${Object.keys(
            this.props.reportData
          )}.propertyRecords[0].records[0].property`
        );
        repRecords = [];
        _.forEach(propRepRecords, (propRepRecord) => {
          const record = _.get(propRepRecord, "record[0]");
          if (record) {
            repRecords.push(record);
          }
        });
      }
      _.forEach(repRecords, (record, index) => {
        const propTitle = `Property ${index + 1}`;
        propTitles.push(propTitle);
        list.push(
          <SimpleAccordionContent
            {...this.props}
            name={propTitle}
            rows={
              <Table.Row>
                <Table.Cell>
                  <Property
                    key={`Rep_Property_Table_${index}`}
                    node={record}
                    index={index}
                    {...this.props}
                  />
                </Table.Cell>
              </Table.Row>
            }
            key={`acc_row_${index}`}
            accId={`acc_row_${index}`}
          />
        );
      });
    }

    return (
      <Segment key="tabContent1" attached id={`report`}>
        <Grid columns={2} stackable>
          <Grid.Row>
            <Grid.Column width={16}>
              <Table className={`no-print`}>
                <Table.Body>
                  <PrintReportCaseHeader
                    {...this.props}
                    actId={actId}
                    onReportPrint={this.onReportPrint}
                  />
                </Table.Body>
              </Table>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={4}>
              <ReportSummary
                onReportIndexChanged={this.onReportIndexChanged}
                itemTitles={propTitles}
                activeSummaryIndex={this.state.activeIndex}
              />
            </Grid.Column>
            <Grid.Column width={12}>
              <Accordion fluid styled>
                {list}
              </Accordion>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
    );
  }
}

export default PropertyReport;



// WEBPACK FOOTER //
// ./src/components/reports/Property/PropertyReport.js